import { createBatchAnimation } from './createBatchAnimation';

export const animateFadeIn = () => {
  if (!document.querySelector('.animate-fade')) {
    return;
  }

  createBatchAnimation({
    selector: '.animate-fade',
    initialState: {
      autoAlpha: 0,
      y: 25,
    },
  });
};
